import styled from 'styled-components';

export const UploadXlsxForm = styled.form`
    display: flex;
    padding: 0;
    
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
        gap: 10px;
        padding: 10px;
    }

    .container > h6{
        text-align: center;
        font-size: 14px;
        color: #F28F1A;
    }

    .input-container{
        display: flex;
        align-items: center;
        justify-content: center;
        height: initial;
        gap: 10px;
    }

    .input-container > p {
        max-width: 110px;
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .input-container > label {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        padding: 5px;
        width: 25px;
        height: 25px;
        text-align: center;
        background-color: #DC4405;
        color: #FFF;
        cursor: pointer;
    }

    .input-container > input[type=file] {
        display: none;
    }

    .button-container {
        display: flex;
        justify-content: center;
    }

    .button-container > .enviar {
        width: 80px;
        padding: 5px;
        background-color: #00A8FF;
        border: 0;
        border-radius: 9px;
        color: #FFF;
        font-weight: bold;

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    .button-container > .exemplo {
        background-color: green;
        color: #fff;
        padding: 5px 10px;
        border-radius: 10px;
        border: none;
    }

    .button-container > .relatorio {
        background-color: #00A8FF;
        color: #fff;
        padding: 5px 10px;
        border-radius: 10px;
        border: none;
    }

    .button-container > button:disabled {
        opacity: 0.5;
        cursor: not-allowed
    }
`